<template>
  <Builder
    v-if="!loading"
    :settings="settings"
  >
    <template #actions>
      <TemplateActions
        :loading="isLoading"
        @save="onSave"
      />
    </template>
  </Builder>
</template>

<script
  lang="ts"
  setup
>
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { emailTemplateFragment } from '@/graphql-fragments';
import { flash, modal } from '@/helpers/ui';
import Builder from '@/modules/marketing/email/builder/index.vue';
import { useMarketingStore } from '../../../store';
import TemplateActions from '../../TemplateActions.vue';

const { t } = useI18n();
const isLoading = ref(false);
const router = useRouter();
const { isInvalid, isSubmitted } = storeToRefs(useMarketingStore());
const { setAttrs, updateEmailTemplate } = useMarketingStore();

const settings = {
  emailType: 'ONLINE_FORMS',
  title: t('marketing.email.automated_emails.online_forms.title'),
  description: t('marketing.email.automated_emails.online_forms.intro'),
  sentDescription: t('marketing.email.automated_emails.online_forms.when'),
  receiveDescription: t(
    'marketing.email.automated_emails.online_forms.receive_info',
  ),
  showToggle: false,
  hideDiscount: true,
  hideButtonToggle: true,
  hideButtonOptions: true,
};

const onSave = () => {
  isSubmitted.value = true;

  if (isInvalid.value) {
    return;
  }

  modal('confirmation').then(() => {
    isLoading.value = true;
    updateEmailTemplate('ONLINE_FORMS').finally(() => {
      router.push({ name: 'marketing-email' });
      flash(t('global.flash.email_saved'));
      isSubmitted.value = false;
      isLoading.value = false;
    });
  });
};

const { result, onResult, loading } = useQuery(
  gql`
    query getEmailTemplate($emailType: EmailTemplateEnum!) {
      emailTemplate(emailType: $emailType) {
        ...emailTemplate
      }
      emailTemplateDefault: emailTemplate(
        emailType: $emailType
        defaultValues: true
      ) {
        ...emailTemplate
      }
    }
    ${emailTemplateFragment}
  `,
  {
    emailType: 'ONLINE_FORMS',
  },
);

onResult(() => {
  if (result.value.emailTemplate) {
    result.value.emailTemplate.emailTemplateDefault =
      result.value.emailTemplateDefault;
    setAttrs(result.value.emailTemplate);
  }
});
</script>
